<script setup>
import { ref } from 'vue';
  const tab = ref({
    1: false,
    2: false,
    3: false,
    4: false,
  })
</script>
<template>
  <div class="text-primary-text mb-10 w-full px-4 pt-[88px] md:mx-auto md:px-8 xl:px-16">
    <div class="mx-auto 4xl:max-w-[1792px]">
      <div class="mb-3 flex flex-col items-start justify-between gap-3 md:flex-row md:items-center">
        <h1 class="text-[32px] font-semibold leading-[110%] tracking-[-0.064px]">
          Stocks under 50
        </h1>
        <span class="text-xs leading-[18px] tracking-[-0.12px] text-text-2">Last updated on
          <!-- -->28 Feb, 2025 | 19:20<!-- -->
          IST | NSE</span>
      </div>
      <div class="flex flex-col items-center justify-between gap-3 sm:flex-row">
        <p class="w-full text-xs leading-[18px] tracking-[-0.12px] text-text-2 sm:max-w-[519px] lg:max-w-[712px]">
          Stocks under ₹50 provide an attractive opportunity to investors who
          want affordable equity market investments. These low-value stocks
          offer an appealing entry point for investors with a limited budget and
          those who want to diversify portfolios. However, investors should
          conduct a thorough research and an analysis of key factors to reduce
          risks associated with these penny stocks, while increasing the chances
          of making gains.
        </p>
      </div>
    </div>
    <div class="table-wrapper mx-auto overflow-x-auto 4xl:max-w-[1792px]">
      <table class="min-w-full 4xl:max-w-[1792px]">
        <thead>
          <tr>
            <th>
              <div class="flex justify-start">
                <span class="cursor-pointer">Name</span>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">LTP</span>
                <div class="ml-1 h-4 w-4">
                  <img alt="filter up" loading="lazy" width="16" height="16" decoding="async" data-nimg="1"
                    class="cursor-pointer" style="color: transparent"
                    src="@/styles/img/next-scrip-assets/SortTable.svg" />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">Change %</span>
                <div class="ml-1 h-4 w-4">
                  <img alt="filter up" loading="lazy" width="16" height="16" decoding="async" data-nimg="1"
                    class="cursor-pointer" style="color: transparent"
                    src="@/styles/img/next-scrip-assets/SortTable.svg" />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">Volume</span>
                <div class="ml-1 h-4 w-4">
                  <img alt="filter up" loading="lazy" width="16" height="16" decoding="async" data-nimg="1"
                    class="cursor-pointer" style="color: transparent"
                    src="@/styles/img/next-scrip-assets/SortTable.svg" />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer text-text-link">Market Cap (Cr.)</span>
                <div class="ml-1 h-4 w-4">
                  <img alt="filter up" loading="lazy" width="16" height="16" decoding="async" data-nimg="1"
                    class="cursor-pointer rotate-180" style="color: transparent"
                    src="@/styles/img/next-scrip-assets/asc.svg" />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">52W high</span>
                <div class="ml-1 h-4 w-4">
                  <img alt="filter up" loading="lazy" width="16" height="16" decoding="async" data-nimg="1"
                    class="cursor-pointer" style="color: transparent"
                    src="@/styles/img/next-scrip-assets/SortTable.svg" />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">52W low</span>
                <div class="ml-1 h-4 w-4">
                  <img alt="filter up" loading="lazy" width="16" height="16" decoding="async" data-nimg="1"
                    class="cursor-pointer" style="color: transparent"
                    src="@/styles/img/next-scrip-assets/SortTable.svg" />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">Prev Close</span>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">PE Ratio</span>
                <div class="ml-1 h-4 w-4">
                  <img alt="filter up" loading="lazy" width="16" height="16" decoding="async" data-nimg="1"
                    class="cursor-pointer" style="color: transparent"
                    src="@/styles/img/next-scrip-assets/SortTable.svg" />
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>INDIAN OVERSEAS BANK</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹43.53
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-4.53<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                38,96,899
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹82,282.20
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹75.55
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹43.20
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹45.60
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                26.71
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>SUZLON ENERGY LIMITED</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹49.71
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-4.64<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                9,31,89,545
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹67,842.59
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹86.04
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹35.50
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹52.13
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                60.62
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>VODAFONE IDEA LIMITED</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹7.55
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-3.2<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                48,24,46,321
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹53,901.74
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹19.18
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹6.61
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹7.80
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>YES BANK LIMITED</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹16.75
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-3.51<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                13,33,32,262
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹52,516.06
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹28.55
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹16.66
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹17.36
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                24.63
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>UCO BANK</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹36.37
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-3.39<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                37,35,621
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹43,483.82
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹62.35
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹35.90
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹37.65
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                18.94
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>CENTRAL BANK OF INDIA</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹43.98
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-2.99<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                38,23,394
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹38,178.77
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹73.00
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹43.25
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹45.34
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                10.86
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>BANK OF MAHARASHTRA</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹46.41
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-2.94<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                66,60,725
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹35,696.51
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹73.50
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹46.11
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹47.82
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                6.93
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>PUNJAB &amp; SIND BANK</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹40.24
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-4.34<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                7,87,480
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹27,273.81
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹73.64
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹40.10
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹42.07
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                32.72
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>IRB INFRA DEV LTD.</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹43.26
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-4.37<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                2,75,47,832
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹26,124.71
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹78.15
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹42.68
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹45.24
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                28.09
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>MOTHERSON SUMI WRNG IND L</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹47.00
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-0.52<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                78,50,112
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹20,779.21
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹80.00
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹46.08
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹47.25
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                33.10
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>SAGILITY INDIA LIMITED</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹42.86
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-0.48<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                53,78,786
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹20,064.17
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹56.40
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹27.02
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹43.07
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>RELIANCE POWER LTD.</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹33.26
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-4.28<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                2,78,73,488
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹13,360.45
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹53.64
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹19.40
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹34.75
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>TRIDENT LIMITED</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹25.79
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-3.15<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                55,85,055
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹13,142.47
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹44.50
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹25.47
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹26.63
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                45.25
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>IFCI LTD</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹41.09
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-3.52<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                90,07,328
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹10,739.25
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹91.40
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹35.80
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹42.59
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                46.69
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>NMDC STEEL LIMITED</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹35.40
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-2.8<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                37,38,746
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹10,374.34
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹68.94
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹34.95
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹36.42
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>JAIPRAKASH POWER VEN. LTD</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹13.36
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-4.09<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                2,53,36,889
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹9,156.22
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹23.77
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹12.85
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹13.93
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                5.94
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>ALOK INDUSTRIES LIMITED</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹15.36
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-2.78<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                41,33,792
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹7,626.61
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹32.00
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹15.23
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹15.80
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>MMTC LIMITED</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹49.49
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-2.77<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                17,96,035
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹7,423.50
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹131.80
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹48.01
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹50.90
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                73.87
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>NETWORK18 MEDIA &amp; INV LTD</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹41.32
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-5.07<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                59,20,519
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹6,371.54
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹120.00
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹40.84
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹43.53
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>THE SOUTH INDIAN BANK LTD</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹23.80
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-3.13<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                95,35,474
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹6,226.78
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹33.70
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹22.27
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹24.57
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                4.86
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>UJJIVAN SMALL FINANC BANK</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹32.13
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-1.5<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                1,36,63,822
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹6,216.46
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹56.70
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹30.88
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹32.62
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                6.17
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>PC JEWELLER LTD</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹11.31
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-positive">1.98<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                2,21,68,096
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹6,108.39
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹19.29
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹4.41
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹11.09
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                17.67
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>HMT LTD -</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹49.05
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-3.38<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                18,691
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹5,906.07
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹105.00
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹41.05
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹50.77
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>LLOYDS ENTERPRISES LTD</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹46.40
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-positive">2.18<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                92,07,562
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹5,902.67
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹63.00
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹41.28
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹45.41
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex cursor-pointer items-center break-words justify-start" style="word-break: break-word">
                <a>SHREE RENUKA SUGARS LTD</a>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹27.51
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                <span class="text-table-negative">-3.91<!-- -->%</span>
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                61,03,602
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹5,855.48
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹56.50
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹27.10
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                ₹28.63
              </div>
            </td>
            <td>
              <div class="flex cursor-pointer items-center justify-end break-words" style="word-break: break-word">
                NA
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="mx-auto mt-3 text-[10px] leading-[15px] tracking-[-0.1px] text-text-2 4xl:max-w-[1792px]">
      *Disclaimer: The scripts listed are solely for research purposes and are
      not recommendations. Please conduct your own research before making any
      investment decisions.
    </p>
    <div class="mx-auto mt-6 flex justify-between 4xl:max-w-[1792px]">
      <div class="hidden items-center md:flex">
        <p class="mr-2 text-text-2">Results per page:</p>
        <div
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg bg-table-paginationBg font-semibold text-text-link">
          <p>25</p>
        </div>
        <div class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg">
          <p>50</p>
        </div>
        <div class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg">
          <p>100</p>
        </div>
      </div>
      <div class="flex flex-col md:hidden">
        <p class="mr-2 text-[10px] leading-[15px] tracking-[-0.10px] text-text-2">
          Results per page:
        </p>
        <div
          class="mt-1 flex h-[34px] w-[81px] cursor-pointer items-center justify-between rounded-lg border border-table-border px-2">
          <p class="text-xs font-semibold leading-[18px] tracking-[-0.12px]">
            25
          </p>
          <img alt="filter up" loading="lazy" width="12" height="12" decoding="async" data-nimg="1" class="rotate-90"
            style="color: transparent" src="@/styles/img/next-scrip-assets/pagination-arrow.svg" />
        </div>
      </div>
      <div class="flex items-center">
        <div class="mr-2 h-4 w-4">
          <img alt="filter up" loading="lazy" width="16" height="16" decoding="async" data-nimg="1"
            class="rotate-180 filter-gray" style="color: transparent"
            src="@/styles/img/next-scrip-assets/pagination-arrow.svg" />
        </div>
        <div
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg bg-table-paginationBg font-semibold text-text-link">
          <p>1</p>
        </div>
        <div class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg">
          <p>2</p>
        </div>
        <div class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg">
          <p>3</p>
        </div>
        <div class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg">
          <p>4</p>
        </div>
        <div class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg">
          <p>5</p>
        </div>
        <div class="ml-2 h-4 w-4">
          <img alt="filter up" loading="lazy" width="16" height="16" decoding="async" data-nimg="1" class=""
            style="color: transparent" src="@/styles/img/next-scrip-assets/pagination-arrow.svg" />
        </div>
      </div>
    </div>
  </div>
  <div class="w-full pb-10 bg-gray-light-background px-4 pt-10 md:px-8 xl:px-16 3xl:px-[200px] 4xl:px-[200px]">
    <div
      class="mx-auto flex w-full flex-col-reverse justify-between md:flex-row md:flex-wrap 3xl:max-w-[1721px] 4xl:max-w-[1490px]">
      <div
        class="w-full md:w-[397px] lg:w-[574px] xl:w-[686px] xxl:w-[817px] 2xl:w-[955px] 3xl:w-[808px] 4xl:w-[908px]">
        <div class="seo-content-penny-stock">
          <h2 class="mb-3 text-xl font-semibold leading-[26.4px] tracking-[-0.24px]">Things to Consider Before Investing
            In Stocks Under ₹50</h2>
          <h3 class="mb-2 text-base font-semibold leading-[26.4px] tracking-[-0.24px]">1. Fundamental Analysis</h3>
          <p class="mb-2 text-sm leading-[21px] tracking-[-0.14px] text-gray-neutral">Fundamental analysis helps
            investors evaluate the intrinsic value of stocks. Investors can use various methods of quantitative and
            qualitative analysis to determine the real value of a stock investment.</p>
          <p class="mb-2 text-sm leading-[21px] tracking-[-0.14px] text-gray-neutral"><span
              class="mr-1 font-bold text-black">● Earnings Per Share (EPS):</span> It is one of the key ratios used in
            fundamental analysis. Usually, a higher EPS suggests higher per-share profit. EPS trends reflect the
            financial health of a company and can help make investment decisions.</p>
          <p class="mb-2 text-sm leading-[21px] tracking-[-0.14px] text-gray-neutral"><span
              class="mr-1 font-bold text-black">● Price to Earnings (P/E) Ratio:</span>The P/E ratio is another
            important tool in fundamental analysis and it compares the stock price to earnings per share. A higher P/E
            ratio suggests that the stock is valued higher than its industry peers and can be costlier to buy.</p>
          <p class="mb-3 text-sm leading-[21px] tracking-[-0.14px] text-gray-neutral"><span
              class="mr-1 font-bold text-black">● Debt to Equity Ratio:</span>The ratio reflects the financial health
            and stability of a company. A higher debt-to-equity ratio suggests the company is more vulnerable to high
            debt levels. This is a key ratio for picking stocks under ₹50.</p>
          <h3 class="mb-3 text-base font-semibold leading-[26.4px] tracking-[-0.24px]">2. Industry trends and
            competitive landscape</h3>
          <p class="mb-3 text-sm leading-[21px] tracking-[-0.14px] text-gray-neutral">An analysis of industry trends,
            performance of various sectors and market trends help assess growth potential, regulatory environment and
            competitive landscape for stocks under ₹50.</p>
          <p class="mb-3 text-sm leading-[21px] tracking-[-0.14px] text-gray-neutral">These penny stocks are more
            vulnerable to economic and political changes, GDP growth, interest rates and others. Investors should be
            wary of economic scenarios and look for sectors that are emerging and have growth potential.</p>
          <h3 class="mb-2 text-base font-semibold leading-[26.4px] tracking-[-0.24px]">3. Liquidity Considerations</h3>
          <p class="mb-3 text-sm leading-[21px] tracking-[-0.14px] text-gray-neutral">Investors must consider the
            liquidity aspect of penny stocks while investing. Stocks under ₹50 are generally less traded and have low
            trading volume. Low liquidity makes it difficult to sell or buy such shares more often.</p>
          <h3 class="mb-2 text-base font-semibold leading-[26.4px] tracking-[-0.24px]">4. Management Quality</h3>
          <p class="mb-3 text-sm leading-[21px] tracking-[-0.14px] text-gray-neutral">Stocks under ₹50 are more
            vulnerable to management changes. Sudden resignation of a top management official can bring high volatility
            in such stocks. Investors must conduct deep research about the top management of a company before committing
            their funds. Good leaders place a company on the growth path and lead to value creation.</p>
          <h3 class="mb-2 text-base font-semibold leading-[26.4px] tracking-[-0.24px]">5. Short Term or Long Term
            Investment Plan</h3>
          <p class="mb-3 text-sm leading-[21px] tracking-[-0.14px] text-gray-neutral">Stocks under ₹50 are usually good
            bets for short term investors. Such stocks have been seen producing lower returns over a long period. Also,
            investors must keep a check on the stock performance regularly for making adjustments as per market trends.
          </p>
        </div>
      </div>
      <div
        class="w-full md:w-[278px] lg:w-[304px] xl:w-[368px] xxl:w-[328px] 2xl:w-[328px] 3xl:w-[380px] 4xl:w-[430px]">
        <div class="mb-10 w-full">
          <h2 class="mb-4 text-xs font-medium leading-[13.2px] tracking-[2.4px] text-gray-neutral">RELATED LINKS</h2>
          <ul class="text-sm leading-[21px] tracking-[-0.14px]">
            <li class="mb-4 cursor-pointer border-b border-b-[#E1E1E1] pb-4 last:mb-0 last:border-b-0"><a
                href="/stocks/penny-stocks/"
                class="text-sm font-semibold leading-[21px] tracking-[-0.14px] text-primary-text">Penny Stocks</a></li>
            <li class="mb-4 cursor-pointer border-b border-b-[#E1E1E1] pb-4 last:mb-0 last:border-b-0"><a
                href="/stocks/stocks-under-10/"
                class="text-sm font-semibold leading-[21px] tracking-[-0.14px] text-primary-text">Stocks under ₹10</a>
            </li>
            <li class="mb-4 cursor-pointer border-b border-b-[#E1E1E1] pb-4 last:mb-0 last:border-b-0"><a
                href="/stocks/stocks-under-20/"
                class="text-sm font-semibold leading-[21px] tracking-[-0.14px] text-primary-text">Stocks under ₹20</a>
            </li>
            <li class="mb-4 cursor-pointer border-b border-b-[#E1E1E1] pb-4 last:mb-0 last:border-b-0"><a
                href="/stocks/stocks-under-100/"
                class="text-sm font-semibold leading-[21px] tracking-[-0.14px] text-primary-text">Stocks under ₹100</a>
            </li>
            <li class="mb-4 cursor-pointer border-b border-b-[#E1E1E1] pb-4 last:mb-0 last:border-b-0"><a
                href="/stocks/stocks-under-200/"
                class="text-sm font-semibold leading-[21px] tracking-[-0.14px] text-primary-text">Stocks under ₹200</a>
            </li>
            <li class="mb-4 cursor-pointer border-b border-b-[#E1E1E1] pb-4 last:mb-0 last:border-b-0"><a
                href="/stocks/stocks-under-500/"
                class="text-sm font-semibold leading-[21px] tracking-[-0.14px] text-primary-text">Stocks under ₹500</a>
            </li>
            <li class="mb-4 cursor-pointer border-b border-b-[#E1E1E1] pb-4 last:mb-0 last:border-b-0"><a
                href="/stocks/stocks-under-1000/"
                class="text-sm font-semibold leading-[21px] tracking-[-0.14px] text-primary-text">Stocks under ₹1000</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="mx-auto mt-9 px-4 md:mt-10 md:px-8 xl:px-16 3xl:max-w-[1322px] 3xl:px-0 4xl:max-w-[1186px]">
    <div class="md:flex">
      <h2
        class="text-primary-text sm:text-xl !m-0 !mb-10 !text-[32px] md:!text-[32px] md:!mb-0 leading-[35.2px] tracking-[-0.64px] font-semibold md:!mr-10 md:!mt-2">
        FAQs</h2>
      <div class="md:flex-1">
        <div class="mb-4 border-b border-b-gray-accent2 pb-4">
          <div>
            <div class="cursor-pointer" @click="tab=1">
              <div
                class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                :data-state="tab===1?'open':'closed'">
                <h3 class="basis-11/12 font-semibold text-primary-text md:basis-full text-xl !my-0">Which are the top 5 stocks
                  under ₹50 by market capitalisation?</h3><span
                  class="group-data-[state=closed]:hidden text-lg font-bold group-data-[state=open]:block"><img alt="chevron-up" loading="lazy"
                    width="20" height="20" decoding="async" data-nimg="1" style="color:transparent"
                    src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"></span><span
                  class="block text-lg font-bold group-data-[state=open]:hidden"><img alt="chevron-up" loading="lazy"
                    width="20" height="20" decoding="async" data-nimg="1" style="color:transparent"
                    src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg"></span>
              </div>
            </div>
            <div
              class="transition-all duration-300 ease-in-out overflow-hidden font-medium text-sm text-gray-accent3 block"
              v-if="tab===1">
              <div class="pr-4 text-sm pb-2 leading-4 font-normal md:leading-6 text-text-2">
                <div>
                  <p class="mb-2">Here are some top stocks under ₹50 in terms of market valuation:</p>
                  <ul class="list-none">
                    <li class="mb-2">1. INDIAN OVERSEAS BANK currently trades at ₹43.53 per share with a market
                      valuation of ₹82,282.20 crore.</li>
                    <li class="mb-2">2. SUZLON ENERGY LIMITED currently trades at ₹49.71 per share with a market
                      valuation of ₹67,842.59 crore.</li>
                    <li class="mb-2">3. VODAFONE IDEA LIMITED currently trades at ₹7.55 per share with a market
                      valuation of ₹53,901.74 crore.</li>
                    <li class="mb-2">4. YES BANK LIMITED currently trades at ₹16.75 per share with a market valuation of
                      ₹52,516.06 crore.</li>
                    <li class="mb-2">5. UCO BANK currently trades at ₹36.37 per share with a market valuation of
                      ₹43,483.82 crore.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-4 border-b border-b-gray-accent2 pb-4">
          <div>
            <div class="cursor-pointer" @click="tab=2">
              <div
                class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                :data-state="tab===2?'open':'closed'">
                <h3 class="basis-11/12 font-semibold text-primary-text md:basis-full text-xl !my-0">How to buy stocks under
                  ₹50?</h3><span class="group-data-[state=closed]:hidden text-lg font-bold group-data-[state=open]:block"><img alt="chevron-up"
                    loading="lazy" width="20" height="20" decoding="async" data-nimg="1" style="color:transparent"
                    src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"></span><span
                  class="block text-lg font-bold group-data-[state=open]:hidden"><img alt="chevron-up" loading="lazy"
                    width="20" height="20" decoding="async" data-nimg="1" style="color:transparent"
                    src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg"></span>
              </div>
            </div>
            <div
              class="transition-all duration-300 ease-in-out overflow-hidden font-medium text-sm text-gray-accent3 block"
              v-if="tab===2">
              <div class="pr-4 text-sm pb-2 leading-4 font-normal md:leading-6 text-text-2">
                <div>
                  <p class="mb-2">Follow these steps if you want to invest in stocks under ₹50:</p>
                  <ul class="list-none">
                    <li class="mb-2">1. Open a Demat Account: Choose a trustworthy brokerage firm for implementing your
                      stock order.</li>
                    <li class="mb-2">2. Search for Stocks: Pick a company based on the assessment of market cap,
                      revenue, profits, and growth potential. A stock screener like Tickertape can be used for picking
                      stocks.</li>
                    <li class="mb-2">3. Place a Buy Order: After shortlisting the stocks, a trading platform can be used
                      to place the buy order.</li>
                    <li class="mb-2">4. Monitor Investments: You should regularly track your investment portfolio. You
                      should be aware of the latest market trends that can help make the right decisions.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-4 border-b border-b-gray-accent2 pb-4">
          <div>
            <div class="cursor-pointer" @click="tab=3">
              <div
                class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                :data-state="tab===3?'open':'closed'">
                <h3 class="basis-11/12 font-semibold text-primary-text md:basis-full text-xl !my-0">Who should buy stocks
                  under ₹50?</h3><span class="group-data-[state=closed]:hidden text-lg font-bold group-data-[state=open]:block"><img
                    alt="chevron-up" loading="lazy" width="20" height="20" decoding="async" data-nimg="1"
                    style="color:transparent"
                    src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"></span><span
                  class="block text-lg font-bold group-data-[state=open]:hidden"><img alt="chevron-up" loading="lazy"
                    width="20" height="20" decoding="async" data-nimg="1" style="color:transparent"
                    src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg"></span>
              </div>
            </div>
            <div
              class="transition-all duration-300 ease-in-out overflow-hidden font-medium text-sm text-gray-accent3 block"
               v-if="tab===3">
              <div class="pr-4 text-sm pb-2 leading-4 font-normal md:leading-6 text-text-2">
                <div>
                  <p class="mb-2">Stocks under ₹50, might be beneficial for:</p>
                  <ul class="list-none">
                    <li class="mb-2">1. Beginners In Stock Markets: Such stocks offer good opportunities for novice
                      investors. They can enter the stock market with low capital and learn from market movements.</li>
                    <li class="mb-2">2. Risk tolerant investors: Penny stocks are vulnerable to market volatility and
                      experience huge swings. Investors who can bear volatile stocks without incurring heavy loss to
                      overall investments can purchase stocks under ₹50.</li>
                    <li class="mb-2">3. Diversification: Stocks under ₹50 provide opportunity for portfolio
                      diversification. Experienced investors can diversify their portfolio by picking low-priced stocks
                      in new sectors and emerging companies.</li>
                    <li class="mb-2">4. Cost Sensitive investors: Investors with tight budgets can enter the stocks
                      under ₹50. However, these should be wary of market volatility and liquidity.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <div>
            <div class="cursor-pointer" @click="tab=4">
              <div
                class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                :data-state="tab===4?'open':'closed'">
                <h3 class="basis-11/12 font-semibold text-primary-text md:basis-full text-xl !my-0">What are the risks
                  associated with stocks under ₹50?</h3><span
                  class="group-data-[state=closed]:hidden text-lg font-bold group-data-[state=open]:block"><img alt="chevron-up" loading="lazy"
                    width="20" height="20" decoding="async" data-nimg="1" style="color:transparent"
                    src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"></span><span
                  class="block text-lg font-bold group-data-[state=open]:hidden"><img alt="chevron-up" loading="lazy"
                    width="20" height="20" decoding="async" data-nimg="1" style="color:transparent"
                    src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg"></span>
              </div>
            </div>
            <div
              class="transition-all duration-300 ease-in-out overflow-hidden font-medium text-sm text-gray-accent3 block"
              v-if="tab===4">
              <div class="pr-4 text-sm pb-2 leading-4 font-normal md:leading-6 text-text-2">
                <div>
                  <p class="mb-2">Some risks associated with stocks under ₹50 include:</p>
                  <ul class="list-none">
                    <li class="mb-2">1. High Volatility: Stocks under ₹50 fluctuate wildly influenced by speculations on
                      company-specific news as well as broader market conditions.</li>
                    <li class="mb-2">2. Low Liquidity: Such stocks generally are marked by low trading volumes and
                      liquidity which make entry as well as exit from these stocks difficult at a reasonable price.</li>
                    <li class="mb-2">3. Lack of Adequate Information: Experts and brokerages usually ignore small
                      companies for evaluations and thus limited information is available on stock potential.</li>
                    <li class="mb-2">4. Scam Risk: These stocks are more prone to manipulations and scams. Investors
                      must pay attention and conduct deep research before making any buying decisions.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  p {
    margin-bottom: 0;
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }
</style>